import Image from 'next/image';
import clsx from 'clsx';

import styles from './Bundle.module.css';
import { useTranslation } from 'next-i18next';

/**
 * @typedef {(typeof import('@data/bundles').bundles)[number]} Bundle
 */

/**
 * @param {{
 *   bundle: Bundle;
 *   onUpgrade: () => Promise<void>;
 * }} props
 *
 * @return {JSX.Element}
 */
export function Bundle({ bundle, onUpgrade }) {
  const { t: tDataPlans } = useTranslation('plans');
  const { t: tt } = useTranslation('plans');
  return (
    <section
      className={clsx(
        'flex flex-col gap-6',
        'p-6',
        'border border-amber-300 rounded-3xl',
      )}
    >
      <h3
        className={clsx(
          'text-center text-[22px] leading-normal font-semibold',
          'm-0 mb-3',
        )}
      >
        {tDataPlans(bundle.name)}
      </h3>

      <div className="flex flex-col items-center gap-4">
        <img
          src={bundle.img}
          alt={bundle.name}
          width={200}
          height={200}
          className={clsx(styles.glowingImage, 'rounded-full')}
        />

        <p className={clsx('m-0', 'text-[18px] text-white/80 font-bold')}>
          {tt('bundles.description', {
            amountOfMessages: bundle.amountOfMessages,
            price: bundle.price + '$',
          })}
        </p>
      </div>

      <div className="flex flex-row justify-center items-center">
        <button
          type="button"
          onClick={onUpgrade}
          className={clsx(
            'py-3 px-8',
            'rounded-full',
            'font-semibold',
            'text-white',
            'bg-blue-600',
          )}
        >
          {tt('bundles.cta')}
        </button>
      </div>
    </section>
  );
}
